import EQUIPMENT_DATA_MODEL_TABLE from "./DataModelTable";

export const TOOL_PANELS = {
  columns: "columns",
  filters: "filters",
  saveConfiguration: "save_configuration",
};

export const entryType = {
  cluster: "CLUSTER",
  standaloneEquipment: "STANDALONE-EQUIPMENT",
  clusterSubequipment: "CLUSTER-SUBEQUIPMENT",
};

export const equipmentStatus = {
  active: { key: "ACTIVE", value: "Active" },
  pending: { key: "PENDING", value: "Pending" },
  deleted: { key: "DELETED", value: "Deleted" },
};

export const enum dropDownSelectionSource {
  agGridFilter = "AG_GRID_FILTER",
  agGridColumn = "AG_GRID_COLUMN",
  nonAgGridFilter = "NON_AG_GRID_FILTER",
  nonAgGridColumn = "NON_AG_GRID_COLUMN",
}

// Strig Constants

export const MY_LAB = "My lab";

export const SOP_RT = "SOP RT0020";

export const YES = "Yes";

export const SNACKBAR_DURATION = 5000;

// Objects
// FIX: Interface for all these objects
export const filterKeyMapping = {
  serialNumber: EQUIPMENT_DATA_MODEL_TABLE.serialNumber.key,
  materialNumber: EQUIPMENT_DATA_MODEL_TABLE.materialNumber.key,
  equipmentId: EQUIPMENT_DATA_MODEL_TABLE.equipmentId.key,
  tags: EQUIPMENT_DATA_MODEL_TABLE.tags.key,
  linkedInstance: EQUIPMENT_DATA_MODEL_TABLE.linkedInstance.key,
  site: EQUIPMENT_DATA_MODEL_TABLE.siteName.key,
  group: EQUIPMENT_DATA_MODEL_TABLE.belongingToGroup.key,
  manufacturer: EQUIPMENT_DATA_MODEL_TABLE.manufacturer.key,
  category: EQUIPMENT_DATA_MODEL_TABLE.equipmentCategory.key,
  responsiblePerson: EQUIPMENT_DATA_MODEL_TABLE.responsiblePerson.key,
  equipmentAdministrator: EQUIPMENT_DATA_MODEL_TABLE.equipmentAdministrator.key,
  dateOfNextMaintanance: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextMaintanance.key,
  dateFrom: "dateFrom",
  dateTo: "dateTo",
  inventoryIds: "_id",
};

export const allTableColumn = () => [
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.serialNumber.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.serialNumber.value,
    order: 1,
    show: true,
    sortStatus: true,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.materialNumber.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.materialNumber.value,
    order: 2,
    show: true,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.equipmentModel.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.equipmentModel.value,
    order: 3,
    show: true,
    sortStatus: true,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.siteName.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.siteName.value,
    order: 4,
    show: true,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.manufacturer.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.manufacturer.value,
    order: 5,
    show: true,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.instrumentGTIN.key,
    val: "GTIN number",
    order: 6,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.equipmentId.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.equipmentId.value,
    order: 7,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.location.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.location.value,
    order: 8,
    show: false,
    sortStatus: true,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.responsiblePerson.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.responsiblePerson.value,
    order: 9,
    show: false,
    sortStatus: true,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.isBookable.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.isBookable.value,
    order: 10,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.instrumentRUDI.key,
    val: "RUDI number",
    order: 11,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.equipmentCategory.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.equipmentCategory.value,
    order: 12,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.comment.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.comment.value,
    order: 13,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.belongingToGroup.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.belongingToGroup.value,
    order: 14,
    show: false,
    sortStatus: true,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.room.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.room.value,
    order: 15,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.systemOwner.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.systemOwner.value,
    order: 16,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.responsibleProxy.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.responsibleProxy.value,
    order: 17,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.sop.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.sop.value,
    order: 18,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.csv.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.csv.value,
    order: 19,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.electronicRecord.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.electronicRecord.value,
    order: 20,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.electronicSignatures.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.electronicSignatures.value,
    order: 21,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextPeriodicReview.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextPeriodicReview.value,
    order: 22,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.maintenancePlan.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.maintenancePlan.value,
    order: 23,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.gxpRelevant.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.gxpRelevant.value,
    order: 24,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.qualificationStatus.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.qualificationStatus.value,
    order: 25,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextMaintanance.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextMaintanance.value,
    order: 26,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.softwareVersion.key,
    val: "Version",
    order: 27,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.configurationBaseline.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.configurationBaseline.value,
    order: 28,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.installedTests.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.installedTests.value,
    order: 29,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.qualificationDocuments.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.qualificationDocuments.value,
    order: 30,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.isVisualized.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.isVisualized.value,
    order: 31,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.dateOfLastMaintanance.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.dateOfLastMaintanance.value,
    order: 32,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.buildingLocation.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.buildingLocation.value,
    order: 33,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.floor.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.floor.value,
    order: 34,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.cluster.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.cluster.value,
    order: 35,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.equipmentAdministrator.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.equipmentAdministrator.value,
    order: 36,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.equipmentNickName.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.equipmentNickName.value,
    order: 37,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.functionalLocation.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.functionalLocation.value,
    order: 38,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.costCenter.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.costCenter.value,
    order: 39,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.inventoryNumber.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.inventoryNumber.value,
    order: 40,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.variant.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.variant.value,
    order: 41,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.documentedMaintenanceDate.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.documentedMaintenanceDate.value,
    order: 42,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.controlledEquipmentStatus.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.controlledEquipmentStatus.value,
    order: 43,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.maintenanceIntervalInDays.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.maintenanceIntervalInDays.value,
    order: 44,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.weightInkg.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.weightInkg.value,
    order: 45,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.weightInlbs.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.heightInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.heightInmm.value,
    order: 46,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.heightIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.lengthInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.lengthInmm.value,
    order: 47,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.lengthIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.depthInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.depthInmm.value,
    order: 48,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.depthIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftInmm.value,
    order: 49,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.clearanceRightInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.clearanceRightInmm.value,
    order: 50,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.clearanceRightIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightInmm.value,
    order: 51,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontInmm.value,
    order: 52,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsInmm.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsInmm.value,
    order: 53,
    show: false,
    sortStatus: false,
    imperialField: EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsIninch.key,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.tags.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.tags.value,
    order: 54,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.linkedInstance.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.linkedInstance.value,
    order: 55,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.systemStatus.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.systemStatus.value,
    order: 56,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.heatOutputInW.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.heatOutputInW.value,
    order: 57,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.pressureEquipment.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.pressureEquipment.value,
    order: 58,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.noiseIndBA.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.noiseIndBA.value,
    order: 59,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.noiseSource.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.noiseSource.value,
    order: 60,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.noiseSourceDetails.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.noiseSourceDetails.value,
    order: 61,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.positioningNote.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.positioningNote.value,
    order: 62,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.positioning.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.positioning.value,
    order: 63,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.vibrationSensitive.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.vibrationSensitive.value,
    order: 64,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.createdAt.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.createdAt.value,
    order: 66,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.updatedAt.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.updatedAt.value,
    order: 67,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.network.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.network.value,
    order: 69,
    show: false,
    sortStatus: false,
  },
  {
    key: EQUIPMENT_DATA_MODEL_TABLE.reviewers.key,
    val: EQUIPMENT_DATA_MODEL_TABLE.reviewers.value,
    order: 70,
    show: false,
    sortStatus: false,
  },
];

export const enum DateTimeType {
  start,
  end,
}

export const DEFAULT_COLUMNS = {
  displayName: "",
  displayDefinition: {
    showColumns: [
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.serialNumber.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.serialNumber.value,
        order: 1,
        show: true,
        sortStatus: true,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.materialNumber.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.materialNumber.value,
        order: 2,
        show: true,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.equipmentModel.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.equipmentModel.value,
        order: 3,
        show: true,
        sortStatus: true,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.siteName.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.siteName.value,
        order: 4,
        show: true,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.manufacturer.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.manufacturer.value,
        order: 5,
        show: true,
        sortStatus: false,
      },
    ],
    hideColumns: [
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.instrumentGTIN.key,
        val: "GTIN number",
        order: 6,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.equipmentId.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.equipmentId.value,
        order: 7,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.location.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.location.value,
        order: 8,
        show: false,
        sortStatus: true,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.responsiblePerson.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.responsiblePerson.value,
        order: 9,
        show: false,
        sortStatus: true,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.isBookable.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.isBookable.value,
        order: 10,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.instrumentRUDI.key,
        val: "RUDI number",
        order: 11,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.equipmentCategory.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.equipmentCategory.value,
        order: 12,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.comment.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.comment.value,
        order: 13,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.belongingToGroup.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.belongingToGroup.value,
        order: 14,
        show: false,
        sortStatus: true,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.room.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.room.value,
        order: 15,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.systemOwner.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.systemOwner.value,
        order: 16,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.responsibleProxy.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.responsibleProxy.value,
        order: 17,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.sop.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.sop.value,
        order: 18,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.csv.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.csv.value,
        order: 19,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.electronicRecord.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.electronicRecord.value,
        order: 20,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.electronicSignatures.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.electronicSignatures.value,
        order: 21,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextPeriodicReview.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextPeriodicReview.value,
        order: 22,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.maintenancePlan.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.maintenancePlan.value,
        order: 23,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.gxpRelevant.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.gxpRelevant.value,
        order: 24,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.qualificationStatus.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.qualificationStatus.value,
        order: 25,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextMaintanance.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.dateOfNextMaintanance.value,
        order: 26,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.softwareVersion.key,
        val: "Version",
        order: 27,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.configurationBaseline.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.configurationBaseline.value,
        order: 28,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.installedTests.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.installedTests.value,
        order: 29,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.qualificationDocuments.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.qualificationDocuments.value,
        order: 30,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.isVisualized.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.isVisualized.value,
        order: 31,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.dateOfLastMaintanance.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.dateOfLastMaintanance.value,
        order: 32,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.buildingLocation.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.buildingLocation.value,
        order: 33,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.floor.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.floor.value,
        order: 34,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.cluster.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.cluster.value,
        order: 35,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.equipmentAdministrator.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.equipmentAdministrator.value,
        order: 36,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.equipmentNickName.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.equipmentNickName.value,
        order: 37,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.functionalLocation.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.functionalLocation.value,
        order: 38,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.costCenter.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.costCenter.value,
        order: 39,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.inventoryNumber.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.inventoryNumber.value,
        order: 40,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.variant.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.variant.value,
        order: 41,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.documentedMaintenanceDate.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.documentedMaintenanceDate.value,
        order: 42,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.controlledEquipmentStatus.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.controlledEquipmentStatus.value,
        order: 43,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.maintenanceIntervalInDays.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.maintenanceIntervalInDays.value,
        order: 44,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.weightInkg.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.weightInkg.value,
        order: 45,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.heightInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.heightInmm.value,
        order: 46,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.lengthInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.lengthInmm.value,
        order: 47,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.depthInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.depthInmm.value,
        order: 48,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftInmm.value,
        order: 49,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.clearanceRightInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.clearanceRightInmm.value,
        order: 50,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightInmm.value,
        order: 51,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontInmm.value,
        order: 52,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsInmm.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsInmm.value,
        order: 53,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.tags.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.tags.value,
        order: 54,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.linkedInstance.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.linkedInstance.value,
        order: 55,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.systemStatus.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.systemStatus.value,
        order: 56,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.heatOutputInW.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.heatOutputInW.value,
        order: 57,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.pressureEquipment.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.pressureEquipment.value,
        order: 58,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.noiseIndBA.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.noiseIndBA.value,
        order: 59,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.noiseSource.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.noiseSource.value,
        order: 60,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.noiseSourceDetails.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.noiseSourceDetails.value,
        order: 61,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.positioningNote.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.positioningNote.value,
        order: 62,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.positioning.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.positioning.value,
        order: 63,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.vibrationSensitive.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.vibrationSensitive.value,
        order: 64,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.createdAt.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.createdAt.value,
        order: 66,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.updatedAt.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.updatedAt.value,
        order: 67,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.network.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.network.value,
        order: 69,
        show: false,
        sortStatus: false,
      },
      {
        key: EQUIPMENT_DATA_MODEL_TABLE.reviewers.key,
        val: EQUIPMENT_DATA_MODEL_TABLE.reviewers.value,
        order: 70,
        show: false,
        sortStatus: false,
      },
    ],
  },
};

export const conversionFields = [
  EQUIPMENT_DATA_MODEL_TABLE.weightInkg.key,
  EQUIPMENT_DATA_MODEL_TABLE.heightInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.lengthInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.depthInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.clearanceBackwardsInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.clearanceHeightInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.clearanceLeftInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.clearanceRightInmm.key,
  EQUIPMENT_DATA_MODEL_TABLE.clearanceToFrontInmm.key,
];

export const listOfSetFieldSearchManipulationQuery = [
  EQUIPMENT_DATA_MODEL_TABLE.qualificationStatus.key,
  EQUIPMENT_DATA_MODEL_TABLE.controlledEquipmentStatus.key
];

export const helpTextColumns = {
  savedColumns: "Here you can see saved columns configuration, click on one to apply.",
  saveCurrentColumns:
    "Save current columns configuration either as an existing or as a new configuration by providing a new name.",
};
export const helpTextFilters = {
  savedFilters: "Here you can see saved filters configuration, click on one to apply.",
  saveCurrentFilters:
    "Save current filters configuration either as an existing or as a new configuration by providing a new name.",
};
